import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=e6cebdf6&"
import script from "./NotFound.vue?vue&type=script&lang=ts&"
export * from "./NotFound.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e6cebdf6')) {
      api.createRecord('e6cebdf6', component.options)
    } else {
      api.reload('e6cebdf6', component.options)
    }
    module.hot.accept("./NotFound.vue?vue&type=template&id=e6cebdf6&", function () {
      api.rerender('e6cebdf6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/molecules/components/NotFound.vue"
export default component.exports